import Vue from 'vue'

const ACCOUNT = {
	ENGAGEMENT_LIST: filter => {
		return Vue.$api.get('/accounts/engagement', { params: { filter: filter } })
	},
	LIST: filter => {
		return Vue.$api.get('/accounts', { params: { filter: filter } })
	},
	BY_ID: id => {
		return Vue.$api.get('/accounts/' + id)
	},
	DELETE: (id, groupId) => {
		return Vue.$api.delete('/accounts/' + id + '/' + groupId)
	},
	TYPE_COUNT: () => {
		return Vue.$api.get('/account-views')
	},
	CREATE: account => {
		return Vue.$api.post('/accounts/', account)
	},

	UPDATE: account => {
		return Vue.$api.patch(`accounts/${account.groupId}/${account.tagId}`)
	},
}

export default ACCOUNT
